import { Injectable } from '@angular/core';
import { VisoPushNotification } from '@viso/core/models';
import { NotificationType } from '@viso/core/enums';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  private $message = new BehaviorSubject<any>({ type: '' });
  constructor(private router: Router) {}

  getInitials(name: string, defaultName = 'VE') {
    const names = (name || '').split(' ');
    names.length > 2 ? (names.length = 2) : null;
    return names.map((n) => n[0]).join('') || defaultName;
  }

  get() {
    return this.$message.asObservable();
  }

  set(data) {
    this.$message.next(data);
  }

  notificationRedirect(
    data: any,
    instantRedirect: boolean = false
  ): string {
    let url = '';

    const type = data.props.message.data.type;
  
    if (type === NotificationType.NewEvent) {
      url = `/event/details/${data.props.message.data.event_id}`;
    } else if (type === NotificationType.RestoreEvent) {
      url = `/event/details/${data.props.message.data.event_id}`;
    } else if (type === NotificationType.Hired) {
      url = `/event/details/${data.props.message.data.event_id}`;
    } else if (
      type === NotificationType.UpdatedQuote ||
      type === NotificationType.NewQuote
    ) {
      url = `/my-event/details/${data.props.message.data.event_id}`;
    } else if (type === NotificationType.Withdrawl) {
      url = `/event/details/${data.props.message.data.event_id}`;
    } else if (type === NotificationType.NewMessage) {
      if (data.user_type === 'client') {
        url = `/chat/messages/${data.props.message.data.sender_id}/${data.props.message.data.event_id}/${data.props.message.data.chat_service_id}`;
      } else {
        url = `/messaging/${data.props.message.data.chat_service_id}/${data.props.message.data.event_uuid}`;
      }
    } else if (
      type === NotificationType.ChatStarted ||
      type === NotificationType.NewConversation
    ) {
      url = `/messaging/${data.props.message.data.chat_service_id}/${data.props.message.data.event_id}`;
    } else if (type === NotificationType.UpdateEvent) {
      url = `/event/details/${data.props.message.data.event_id}`;
    } else if (type === NotificationType.UpdateInvitation) {
      url = `/invitations/details/${data.props.message.data.invitation_id}`;
    } else if (type === NotificationType.UpdateInvitationApprovalStatus) {
      url = '/invitations/list';
    } else if (type === NotificationType.UpdateInvitationDetails) {
      url = '/invitations/list';
    } else if (type === NotificationType.UpdateInvitationResponseDetails) {
      url = `/invitations/details/${data.props.message.data.invitation_id}`;
    } else if (type === NotificationType.DiscountUpdated || type === NotificationType.DiscountRemove) {
      url = `/my-event/details/${data.props.message.data.props.event_id}?discount=${data.props.message.data.props.quote_uuid}`;
    }
  
    this.set({ type });
  
    if (instantRedirect) {
      this.router.navigateByUrl(url);
    }
  
    return url;
  }
  

  scrollToBottom(ionContent: any, timer = 1000) {
    setTimeout(() => {
      ionContent?.scrollToBottom(300);
    }, timer);
  }

  getFormattedText(body) {
    return body.replace(new RegExp('\n', 'g'), '<br />');
  }
}
